var rmUtil = require("../rmlibrary_old/util");
var PDFCanvasNode = require("./canvas");
var _r = require;
var canvg = (function () {
    try {
        // eslint-disable-next-line no-undef
        return window.canvg;
    }
    catch (e) {
        // Do nothing
    }
    try {
        var r = _r("canvg");
        return r;
    }
    catch (e) {
        // Do nothing
    }
})();
var DOMParser = (function () {
    try {
        // eslint-disable-next-line no-undef
        return window.DOMParser;
    }
    catch (e) {
        // Do nothing
    }
    try {
        var r = _r("xmldom");
        return r.DOMParser;
    }
    catch (e) {
        // Do nothing
    }
})();
var fetch = (function () {
    try {
        // eslint-disable-next-line no-undef
        return window.fetch;
    }
    catch (e) {
        // Do nothing
    }
    try {
        var r = _r("node-fetch");
        return r;
    }
    catch (e) {
        // Do nothing
    }
})();
function outerHTML(node) {
    var tmpDiv = node.ownerDocument.createElement("div");
    var clone = node.cloneNode(true);
    tmpDiv.appendChild(clone);
    var outerHTML = tmpDiv.innerHTML;
    tmpDiv.innerHTML = "";
    return outerHTML;
}
function PDFSVGNode(node) {
    PDFCanvasNode.apply(this, arguments);
    this.generateFn = function (doc, cursor, canvas) {
        if (!canvg) {
            return;
        }
        var svgText = (node.outerHTML || outerHTML(node)).replace(/xmlns="http:\/\/www.w3.org\/2000\/svg"/, "");
        var preset = canvg.presets.node({
            DOMParser: DOMParser,
            fetch: fetch,
            canvas: {
                createCanvas: function () {
                    throw new Error("Not supported!");
                },
                loadImage: function () {
                    throw new Error("Not supported!");
                },
            },
        });
        var ctx = canvas.getContext("2d");
        var _canvg = canvg.Canvg.fromString(ctx, svgText, preset);
        _canvg.render();
    };
}
rmUtil.inherits(PDFSVGNode, PDFCanvasNode);
PDFSVGNode.prototype.getDataUri = function () {
    return "";
};
module.exports = PDFSVGNode;
//# sourceMappingURL=module.js.map